'use client';

import { LoyaltyStatus } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/LoyaltyStatus';
import { Link } from '@packages/modules/src/Link/Link';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useLoginState } from '@packages/shared/src/hooks/useLoginState/useLoginState';
import { useLoyaltyApi } from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import { buttonVariants } from '@packages/shared/src/ui/Button/Button.variants';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { defineMessages, useIntl } from 'react-intl';
import useSWR from 'swr';

const messages = defineMessages({
  PaybackInactiveStatusHeadline: {
    defaultMessage: 'Danke, dass du dein PAYBACK Konto bereits verknüpft hast.',
    id: 'Payback.Inactive.Headline',
  },
  PaybackInactiveStatusSubLine: {
    defaultMessage:
      'Um die PAYBACK-Anmeldung erfolgreich abzuschließen, bitten wir dich, dich erneut anzumelden.',
    id: 'Payback.Inactive.Subline',
  },
  ConnectPaybackButton: {
    defaultMessage: 'Bei PAYBACK anmelden',
    id: 'Payback.Inactive.Button',
  },
});

type MyAccountContainerProps = {
  testId?: string;
};

export const PaybackReauthenticate: React.FC<MyAccountContainerProps> = ({
  testId = 'myaccount-payback-reauthenticate',
}) => {
  const { loggedIn } = useLoginState();
  const { locale, formatMessage } = useIntl();
  const loyaltyApi = useLoyaltyApi();
  const { data } = useSWR(
    loyaltyApi && loggedIn ? 'getLoyaltyLoginUrl' : null,
    () =>
      loyaltyApi?.getLoyaltyLoginUrl({
        ecLocale: locale,
        loyaltyStatus: LoyaltyStatus.ReauthenticationNeeded,
      }),
    { revalidateOnFocus: false },
  );
  const {
    company: { name: companyName },
  } = useConfig();

  return (
    <div
      data-testid={testId}
      className="flex w-full flex-col items-center justify-center gap-1.5 px-1.5 py-2.5 md:gap-2 md:p-3"
    >
      <span className="icon-emp-company-logo-payback h-[3.5rem] w-[6.5rem]" />
      <p className="text-size-body-base text-center">
        {formatMessage(messages.PaybackInactiveStatusHeadline)}
      </p>
      <p className="text-size-body-sm flex flex-col gap-0.5 text-center">
        {formatMessage(messages.PaybackInactiveStatusSubLine, {
          companyName,
          break: <br />,
        })}
      </p>
      {data?.url && (
        <Link
          href={data.url}
          className={cn(
            buttonVariants({ color: 'primary' }),
            'text-size-body-sm items-center justify-start',
          )}
        >
          {formatMessage(messages.ConnectPaybackButton)}
        </Link>
      )}
    </div>
  );
};
